import {
  select,
  selectAll,
  axisBottom,
  axisLeft,
  scaleBand,
  scaleLinear,
} from "d3";

const isLabelMatch = (label, variantQueryMode) => {
  const variantQueryModeParams = variantQueryMode;
  let searchQueries = [];
  if (
    variantQueryModeParams &&
    variantQueryModeParams.cancer_type &&
    variantQueryModeParams.cancer_type.length > 0
  ) {
    searchQueries = searchQueries.concat(variantQueryModeParams.cancer_type);
  }
  if (
    variantQueryModeParams &&
    variantQueryModeParams.tissue_type &&
    variantQueryModeParams.tissue_type.length > 0
  ) {
    searchQueries = searchQueries.concat(variantQueryModeParams.tissue_type);
  }
  let color = "neutral";
  searchQueries.forEach((item) => {
    if (label.toLowerCase().includes(item.toLowerCase())) {
      color = "highlight";
    }
  });
  return color;
};

export const drawData = (
  data,
  containerRef,
  containerWidth,
  uniqueKey,
  yAxisTitle,
  xAxisTitle,
  variantQueryMode
) => {
  const margin = { top: 20, right: 50, bottom: 220, left: 70 };
  const colNum = Object.keys(data).length;
  const minColWidth = 40;
  const w = colNum * minColWidth + margin.left + margin.right;
  const updatedWidth = Math.max(
    containerRef.current.offsetWidth,
    containerWidth
  );
  const width = Math.min(updatedWidth, w);
  const inWidth = width - margin.left - margin.right;

  selectAll(`#rpkm_expressions_d3${uniqueKey} > svg > *`).remove();

  const svg = select(`#rpkm_expressions_d3${uniqueKey} > svg`).attr(
    "width",
    width
  );
  const height = +svg.attr("height") - margin.top - margin.bottom;
  const x = scaleBand().rangeRound([0, inWidth]).padding(0.1);
  const y = scaleLinear().rangeRound([height, 0]);
  const g = svg
    .append("g")
    .attr("transform", `translate(${margin.left},${margin.top})`);

  // get max value for y axis
  let maxy = 0;
  for (let i = data.length - 1; i >= 0; i--) {
    const val = parseFloat(data[i].value);
    if (val > maxy) {
      maxy = val;
    }
  }

  x.domain(
    data.map((d) => {
      return d.expression;
    })
  );
  y.domain([0, maxy]).nice();

  g.append("g")
    .attr("class", "axis axis--x")
    .attr("transform", `translate(0,${height})`)
    .call(axisBottom(x))
    .selectAll("text")
    .attr("class", "varsome-axis-label")
    .style("text-anchor", "start")
    .attr("dx", ".8em")
    .attr("dy", "-.15em")
    .attr("transform", "rotate(60)");

  g.append("g")
    .attr("class", "varsome-axis axis--y")
    .call(axisLeft(y).ticks())
    .append("text")
    .attr("class", "varsome-axis-label")
    .attr("y", 6)
    .attr("dy", "0.71em")
    .attr("text-anchor", "end")
    .text("value");

  g.append("text")
    .attr("text-anchor", "middle") // this makes it easy to centre the text as the transform is applied to the anchor
    .attr("transform", `translate(-60,${height / 2}) rotate(-90)`) // text is drawn off the screen top left, move down and out and rotate
    .text(yAxisTitle || "");

  g.append("text")
    .attr("text-anchor", "middle") // this makes it easy to centre the text as the transform is applied to the anchor
    .attr("transform", `translate(${width / 2}, ${height + 210}) rotate(0)`) // centre below axis
    .text(xAxisTitle || "");
  g.selectAll(".bar")
    .data(data)
    .enter()
    .append("rect")
    .attr("x", (d) => {
      return x(d.expression);
    })
    .attr("y", (d) => {
      return y(d.value);
    })
    .attr("width", x.bandwidth())
    .attr("height", (d) => {
      return height - y(d.value);
    })
    .attr("class", (d) => {
      if (isLabelMatch(d.expression, variantQueryMode) === "neutral") {
        return "varsome-rpkm-bar";
      }
      if (isLabelMatch(d.expression, variantQueryMode) === "highlight") {
        return "varsome-rpkm-bar--highlight";
      }
      return "varsome-rpkm-bar";
    })
    .append("title")
    .text((d) => {
      return d.value;
    });
};
